import React from 'react'
import PropTypes from 'prop-types'
import * as Displays from 'support/displays'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import { useModelValue, WhenModelValue } from '@morningtrain/react-resources'
import moment from 'moment'
import AdjustScheduleButton from 'widgets/smartviews/partials/AdjustScheduleButton'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import SquareButton from 'ui/buttons/SquareButton'
import { Translation } from '@morningtrain/react-translations'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import ViewSpecialEventsSmartview from 'widgets/smartviews/ViewSpecialEventsSmartview'
import * as UI from 'ui'
import { ButtonWrap } from 'ui'
import upperFirst from 'lodash/upperFirst'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'

function DaySummary (props) {
  const date = moment(useModelValue('date'))

  const { scheduleId,weekDay } = props
  return (
    <>
      <Can permission={Permissions.SHIFTS_ADJUST_FORECAST}>
        <div className='flex items-center justify-between'>
          <span className='text-xl font-medium'>{upperFirst(date.format('dddd'))}</span>
          <div className='group space-x-1'>
            <AdjustScheduleButton scheduleId={scheduleId} step={-500} weekDay={weekDay}>
              <SquareButton color='btn-lightgray'>
                <svg className='w-3' width='12' height='1.091' viewBox='0 0 12 1.091'>
                  <path d='M96,202.668h12v1.091H96Zm0,0' transform='translate(-96 -202.668)' />
                </svg>
              </SquareButton>
            </AdjustScheduleButton>
            <AdjustScheduleButton scheduleId={scheduleId} step={500} weekDay={weekDay}>
              <SquareButton color='btn-lightgray'>
                <svg className='w-3' width='12' height='12' viewBox='0 0 12 12'>
                  <g transform='translate(-3.6 -3.6)'>
                    <path d='M96,202.668h12v1.091H96Zm0,0' transform='translate(-92.4 -193.613)' />
                    <path d='M202.668,96h1.091v12h-1.091Zm0,0' transform='translate(-193.613 -92.4)' />
                  </g>
                </svg>
              </SquareButton>
            </AdjustScheduleButton>
          </div>
        </div>
        <SmartviewContentSeparator />
      </Can>

      <SmartviewTextGroup highlight>
        <SmartviewText
          label={<><span><Translation name='forecast' /></span> <Displays.Currency name='forecast' decimals={0} /></>}
        >
          <div className='flex justify-between'><span><Translation name='adjustment' /></span> <Displays.Currency
            name='adjustment' decimals={0}
                                                                                               />
          </div>
          <div className='flex justify-between'><span><Translation name='total' /></span> <Displays.Currency
            name='total_forecast' decimals={0}
                                                                                          />
          </div>
          <div className='flex justify-between'><span><Translation name='expected_guest_count' /></span>
            <Displays.Integer name='expected_guest_count' />
          </div>
        </SmartviewText>
        <SmartviewText
          label={<><span><Translation name='locked_budget' /></span> <Displays.Currency
            name='forecast_locked_budget'
            decimals={0}
                                                                     />
          </>}
        >
          <div className='flex justify-between'><span><Translation name='locked_guest_count' /></span> <Displays.Integer
            name='locked_expected_guest_count'
                                                                                                       />
          </div>
          <div className='flex justify-between'><span><Translation name='wage_ratio' /></span> <Displays.Percentage
            name='salary_percentage_locked_budget' decimals={2}
                                                                                               />
          </div>
        </SmartviewText>
        <SmartviewText label={<><span><Translation name='salary_budget' /></span> <Displays.Currency
          name='salary_budget'
          decimals={0}
                                                                                  />
        </>}
        >
          <div className='flex justify-between'><span><Translation name='salary_expenses' /></span> <Displays.Currency
            name='salary_expenditure' decimals={0}
                                                                                                    />
          </div>
          <div className='flex justify-between'><span><Translation name='balance' /></span> <Displays.Currency
            name='salary_balance' decimals={0}
                                                                                            />
          </div>
          <div className='flex justify-between'><span><Translation name='wage_ratio' /></span> <Displays.Percentage
            name='salary_percentage' decimals={2}
                                                                                               />
          </div>
        </SmartviewText>
      </SmartviewTextGroup>

      <SmartviewContentSeparator />

      <SmartviewText label={<Translation name='historical_revenue' />}>
        <div className='flex justify-center'>
          <UI.Text>
            <Translation
              name='generic.this_year'
            />
          </UI.Text>
        </div>
        <div className='flex justify-between'>
          <UI.Text>
            <Translation
              name='weekday_week'
              data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 4 }}
            />
          </UI.Text>
          <Displays.Currency name='realised_revenue3' decimals={0} />
        </div>
        <div className='flex justify-between'>
          <UI.Text>
            <Translation
              name='weekday_week'
              data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 3 }}
            />
          </UI.Text>
          <Displays.Currency name='realised_revenue2' decimals={0} />
        </div>
        <div className='flex justify-between'>
          <UI.Text>
            <Translation
              name='weekday_week'
              data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 2 }}
            />
          </UI.Text>
          <Displays.Currency name='realised_revenue1' decimals={0} />
        </div>
        <div className='flex justify-between'>
          <UI.Text>
            <Translation
              name='weekday_last_week_number'
              data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 1 }}
            />
          </UI.Text>
          <Displays.Currency name='realised_revenue' decimals={0} />
        </div><br/>
        <div className='flex justify-center'>
          <UI.Text>
            <Translation
              name='generic.last_year'
            />
          </UI.Text>
        </div>
        <div className='flex justify-between'>
          <UI.Text>
            <Translation
              name='weekday_week'
              data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 4 }}
            />
          </UI.Text>
          <Displays.Currency name='realised_revenue_last_year_week4' decimals={0} />
        </div>
        <div className='flex justify-between'>
          <UI.Text>
            <Translation
              name='weekday_week'
              data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 3 }}
            />
          </UI.Text>
          <Displays.Currency name='realised_revenue_last_year_week3' decimals={0} />
        </div>
        <div className='flex justify-between'>
          <UI.Text>
            <Translation
              name='weekday_week'
              data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 2 }}
            />
          </UI.Text>
          <Displays.Currency name='realised_revenue_last_year_week2' decimals={0} />
        </div>
        <div className='flex justify-between'>
          <UI.Text>
            <Translation
              name='weekday_week'
              data={{ weekday: upperFirst(date.format('dddd')), week: date.week() - 1 }}
            />
          </UI.Text>
          <Displays.Currency name='realised_revenue_last_year_week1' decimals={0} />
        </div>
        <div className='flex justify-between'>
          <UI.Text>
            <Translation
              name='weekday_week'
              data={{ weekday: upperFirst(date.format('dddd')), week: date.week()}}
            />
          </UI.Text>
          <Displays.Currency name='realised_revenue_last_year' decimals={0} />
        </div>
      </SmartviewText>

      <WhenModelValue name='special_days_count'>
        <SmartviewContentSeparator className='my-4' />
        <ButtonWrap center>
          <MountSmartviewOnClick
            smartview={<ViewSpecialEventsSmartview scheduleId={scheduleId} date={date.format('YYYY-MM-DD')} />}
            replace={false}
          >
            <UI.Button>
              <Translation name='view_special_days' data={{ amount: 'model:special_days_count' }} />
            </UI.Button>
          </MountSmartviewOnClick>
        </ButtonWrap>
      </WhenModelValue>

    </>
  )
}

DaySummary.defaultProps = {}

DaySummary.propTypes = {
  weekDay: PropTypes.number.isRequired
}

export default DaySummary
